module.exports = __webpack_public_path__ + "img/pwa-install-popup-btn.ba2b002e.png";